module.exports = __webpack_public_path__ + "static/media/state-ready.4997c74d.svg";